import type { UUID } from "utils";

const BASE_URL = "/administration/backoffice/accounts";
const TRANSACTIONS_URL = `${BASE_URL}/transactions`;

export const PAGE_URLS = {
  home: "/",
  base: BASE_URL,
  transactions: TRANSACTIONS_URL,
  transactionDetails: `${TRANSACTIONS_URL}/:id`,
  getLinkToTransactionDetails: (id: UUID) => `${TRANSACTIONS_URL}/${id}`,
} as const;
